import { createFileRoute } from '@tanstack/react-router'
import { VeiculoTiposPage } from '@/pages/veiculo-tipos/VeiculoTiposPage'

export const Route = createFileRoute('/_auth/veiculo-tipos')({
  component: VeiculoTiposPage,
})
